import { ConditionOperator } from '../../constants/conditions_operator_picker';

export interface DesignerSchemaFieldI {
  name?: string;
  alias?: string;
  data_type?: string;
  projected_name?: string;
  id?: string;
  FC_pristine?: boolean;
  fields?: string[];
  isFocused?: boolean;
  isDuplicateError?: boolean;
  isOutsideDuplicateError?: boolean;
  left?: string;
  operator?: ConditionOperator;
  right?: string;
  function_name?: string;
  projected_field_name?: string;
  field_name?: string;
  group_type?: string;
  order_type?: string;
  ntiles?: string;
  offset?: string;
  default_value?: string;
  range_after?: string;
  range_before?: string;
  value?: string;
  column_name?: string;
  relationship_field_name?: string;
  relationship_name?: string;
  field_type?: string;
  relationKeys?: DesignerSchemaFieldI[];
  required?: boolean;
  reference_to?: string[];
  is_required?: boolean;
  is_keyable?: boolean;
  is_updateable?: boolean;
  type?: string;
  is_reference_key?: boolean;
  is_bson?: boolean;
  is_merge_key?: boolean;
}

export class DesignerSchemaField {
  name = '';
  alias = '';
  data_type = 'string';
  projected_name?: string;
  left?: string;
  operator?: ConditionOperator;
  right?: string;
  function_name?: string;
  field_name?: string;
  field_type?: string;
  column_name?: string;
  required?: boolean;

  constructor(data: Partial<DesignerSchemaFieldI>) {
    this.setData(data);
  }

  setData(data: Partial<DesignerSchemaFieldI>) {
    this.name = data.name || this.name;
    this.alias = data.alias || this.alias;
    this.data_type = data.data_type || this.data_type;
    this.projected_name = data.projected_name || this.projected_name;
  }

  getData(): DesignerSchemaFieldI {
    return {
      name: this.name,
      alias: this.alias,
      data_type: this.data_type,
      projected_name: this.projected_name,
    };
  }
}
